import React from 'react'
import loadingImage from '../assets/weatherStation.png'
import './styles/LoadingSplash.css'

const LoadingSplash = (props) => {
  if(props.isFetching) {
    return (
      <div className="loadingSplash fullTake">
      <div className="loadingSplashTitle fullTakeTitle">
        {props.title}
      </div>
        <img className="loadingSplashImage fullTakeImage" alt="loading" src={loadingImage} />
        <div className="loadingSplashMessage fullTakeMessage">
          {props.message}
        </div>
      </div>
    )
  } else {
    return (
      <div className="loadingSplash">
        {props.children}
      </div>
    )
  }
}

export default LoadingSplash



// WEBPACK FOOTER //
// ./src/components/LoadingSplash.js